import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  API_SERVER: string = environment.baseApiUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  findAll(): Observable<any> {
    return this.httpClient.get(this.API_SERVER + 'role').pipe(
      map(this.extractData)
    )
  }

  countByAssignedRole() {
    return this.httpClient.get(this.API_SERVER + 'role/count-by-assigned-role').pipe(
      map(this.extractData)
    )
  }
}
